export default __webpack_public_path__ + "static/media/greyWave.e9ed7f9b.svg";